







import Filters, { FilterItem, FILTER_TYPES } from '@/components/common/filters/index.vue';
import FilterTrigger from '@/components/common/filters/trigger.vue';
import { GET_OFFERS_DATA, PAYLOAD_GETOFFR, SHOW_OFFERS_FILTERS } from '@/store/modules/offersModule';

export default {
    data() {
        return {
            hiddenFilters: true,
            filterOnMountCalled: false,
            filters: [
                {
                    type: FILTER_TYPES.TEXT,
                    key: 'offerid',
                    placeholder: 'Input offer id',
                },
                {
                    type: FILTER_TYPES.TEXT,
                    key: 'client',
                    placeholder: 'Insert Client',
                },
            ] as FilterItem[],
        };
    },
    components: {
        FilterTrigger,
        Filters,
    },

    methods: {
        showFilters(this: any) {
            this.hiddenFilters = !this.hiddenFilters;
            this.$store.commit(SHOW_OFFERS_FILTERS, this.hiddenFilters);
        },
        getFilterValueByKey(this: any, items: FilterItem[], key: string): string | undefined {
            const filter = items.find((item: FilterItem) => item.key === key);
            if (filter && filter.value) {
                return filter.value;
            }

            return undefined;
        },
        updateData(this: any, items: FilterItem[]) {
            const query:any = {
                offerId: this.getFilterValueByKey(items, 'offerid'),
                customerName: this.getFilterValueByKey(items, 'client'),
            };

            this.$store.commit(PAYLOAD_GETOFFR, query);
            if (this.filterOnMountCalled) { this.$store.dispatch(GET_OFFERS_DATA, this.$store.getters.getOfferPayloads); }

            this.filterOnMountCalled = true;
        },
    },
};
